"use client";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import Link from "next/link";

export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);

  const links = [
    { href: "/", label: "Home" },
    { href: "/about-us/", label: "About" },
    { href: "/rooms/", label: "Rooms" },
    { href: "/activities/", label: "Activities" },
    { href: "/attractions/", label: "Attractions" },
    { href: "/gallery/", label: "Gallery" },
    { href: "/blogs/", label: "Blogs" },
    { href: "/contact-us/", label: "Contact" },
  ];

  return (
    <>
      <button
        className="md:hidden text-[#5A3A1E] p-2 z-41"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-40 bg-[#F3EBDD] md:hidden pt-20">
          <div className="flex flex-col items-center gap-8 p-8 bg-[#F3EBDD]">
            {links.map(({ href, label }) => (
              <Link
                key={href}
                href={href}
                className="text-2xl text-[#5A3A1E] hover:text-[#7A4A1D] transition-colors"
                onClick={() => setIsOpen(false)}
              >
                {label}
              </Link>
            ))}
            <Link href="/contact-us/" onClick={() => setIsOpen(false)}>
              <button className="bg-[#E07A2F] text-white px-8 py-4 rounded-full hover:bg-[#c96a28] transition-all shadow-md text-lg mt-4">
                Book Now
              </button>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
